import { useRef, useState, useEffect } from "react";
import Header from "../components/layout/header";
import Footer from "../components/layout/footer";
import Banner from '../components/common/banner';
import Breadcrumb from '../components/common/breadcrumb';
import styles from "./Introduction.module.css";
import axios from 'axios';

function IntroductionPage() {
  const [listUni, setListUni] = useState([]);
  const headerRef = useRef(null);

  const handleScroll = (id) => {
    const el = document.getElementById(id);
    if (!el) return;

    const headerHeight = headerRef.current?.offsetHeight || 0;

    const y =
      el.getBoundingClientRect().top +
      window.pageYOffset -
      headerHeight;

    window.scrollTo({ top: y, behavior: "smooth" });

    // Đảm bảo URL không có hash
    window.history.replaceState(
      null,
      "",
      window.location.pathname
    );
  };

  const getListUniversity = async () => {
    const response = await axios.get("https://duhochanquocnewlife.com/api/universities/getListUniversity")
    setListUni(response.data.data);
  }

  useEffect(() => {
    getListUniversity();
  }, [])

  const toString = (str) => {
    return str
      .trim()
      .split(/\s+/)     // tách theo khoảng trắng
      .slice(0, -1)     // bỏ phần tử cuối
      .map(word => word.toLowerCase())
      .join('_');
  }

  const timelineData = [
    {
      year: "2016",
      text: "Thành lập Trung tâm Du học NewLife",
      position: "bottom",
      color: "blue",
    },
    {
      year: "2017 - 2022",
      text: "Mở rộng đào tạo tiếng Hàn, ký kết hợp tác với nhiều trường Hàn Quốc",
      position: "top",
      color: "orange",
    },
    {
      year: "2023",
      text: "Thành lập chi nhánh Thái Bình & Vĩnh Phúc",
      position: "bottom",
      color: "blue",
    },
    {
      year: "2024 - Nay",
      text: "Thành lập văn phòng đại diện tại Seoul, Hàn Quốc. Sau đó tiếp tục phát triển cho đến nay",
      position: "top",
      color: "orange",
    },
  ];

  return (
    <>
      <Header ref={headerRef} />

      <Banner
        imageSrc="/images/newlife.jpg"
        title="Giới thiệu trung tâm"
      />

      <div className='container'>
        <Breadcrumb />

        <div className={styles.container_intro}>
          <div className={styles.table}>
            <h2 className={styles.table_title}>Mục lục</h2>
            <ul className={styles.table_list}>
              <li className={styles.table_item} onClick={() => handleScroll("about-us")}>1. Về chúng tôi</li>
              <li className={styles.table_item} onClick={() => handleScroll("company")}>2. Công ty TNHH NewLife</li>
              <li className={styles.table_item} onClick={() => handleScroll("management")}>3. Ban lãnh đạo công ty</li>
              <li className={styles.table_item} onClick={() => handleScroll("history")}>4. Lịch sử hình thành</li>
              <li className={styles.table_item} onClick={() => handleScroll("message")}>5. Thông điệp công ty</li>
              <li className={styles.table_item} onClick={() => handleScroll("service")}>6. Dịch vụ của NewLife</li>
              <li className={styles.table_item} onClick={() => handleScroll("admission")}>7. Quy trình tuyển sinh và đào tạo</li>
              <li className={styles.table_item} onClick={() => handleScroll("difference")}>8. Điểm khác biệt</li>
              <li className={styles.table_item} onClick={() => handleScroll("university")}>9. Hệ thống trường đối tác</li>
            </ul>
          </div>

          <div className={styles.content}>
            {/* 1. Về chúng tôi */}
            <div id="about-us" className={styles.content_detail}>
              <h3 className={styles.content_title}>1. Về chúng tôi</h3>
              <p>
                <strong>Trung tâm Du học Hàn Quốc NewLife</strong> được thành lập với sứ mệnh đồng hành cùng học sinh Việt Nam trên hành trình chinh phục tri thức và hiện thực hóa ước mơ du học Hàn Quốc.
              </p>
              <p>
                Với triết lý giáo dục “lấy học sinh làm trung tâm”, NewLife xây dựng mô hình đào tạo hiệu quả, chú trọng sự tương tác hai chiều giữa giáo viên và học viên, giúp nâng cao năng lực tiếng Hàn, phát triển tư duy và rèn luyện kỹ năng hội nhập quốc tế. Chúng tôi không chỉ dừng lại ở việc đào tạo ngôn ngữ, mà còn đồng hành toàn diện từ tư vấn, định hướng nghề nghiệp, hỗ trợ hồ sơ – visa, xuất cảnh và quản lý học sinh trong suốt quá trình học tập tại Hàn Quốc.
              </p>

              <div className={styles.info}>
                <div className={styles.info_detail}>
                  <span>+700</span>
                  <p>Du học sinh thành công tại Hàn Quốc</p>
                </div>
                <div className={styles.info_detail}>
                  <span>+30</span>
                  <p>Hợp tác các trường Đại học & Cao đẳng</p>
                </div>
                <div className={styles.info_detail}>
                  <span>+1500</span>
                  <p>Học viên tốt nghiệp tại NewLife</p>
                </div>
              </div>

              <p>Trung tâm sở hữu đội ngũ giảng viên trình độ cao với nhiều năm kinh nghiệm, đảm bảo nền tảng ngôn ngữ vững chắc cho học viên. Giảng viên am hiểu chương trình du học Hàn Quốc và áp dụng phương pháp giảng dạy linh hoạt, giúp học viên tiếp thu hiệu quả và tự tin sử dụng tiếng Hàn trong học tập cũng như giao tiếp thực tế.</p>

              <div className={styles.icons}>
                <div className={styles.icon_detail}>
                  <img src="/icons/user_green.svg" alt="Chuyên nghiệp" />
                  <p>Chuyên nghiệp</p>
                </div>
                <div className={styles.icon_detail}>
                  <img src="/icons/graduation_green.svg" alt="Kinh nghiệm" />
                  <p>Kinh nghiệm</p>
                </div>
                <div className={styles.icon_detail}>
                  <img src="/icons/heart_green.svg" alt="Tâm huyết" />
                  <p>Tâm huyết</p>
                </div>
              </div>
            </div>

            {/* 2. Công ty TNHH NewLife */}
            <div id="company" className={styles.content_detail}>
              <h3 className={styles.content_title}>2. Công ty TNHH NewLife</h3>

              <div className={styles.comp_info}>
                <div className={styles.group_info}>
                  <div className={styles.comp_title}>
                    <div className={styles.comp_img}><img src="/icons/company.svg" alt="Tên trung tâm" /></div>
                    <h4>Tên trung tâm:</h4>
                  </div>
                  <div className={styles.comp_detail}>
                    <p>Trung tâm Du học Hàn Quốc NewLife</p>
                  </div>
                </div>
              </div>

              <div className={styles.comp_info}>
                <div className={styles.group_info}>
                  <div className={styles.comp_title}>
                    <div className={styles.comp_img}><img src="/icons/address.svg" alt="Trụ sở" /></div>
                    <h4>Trụ sở chính:</h4>
                  </div>
                  <div className={styles.comp_detail}>
                    <p>Số 9, 58C phố Xuân Nương, 6C phường Nông Trang, thành phố Việt Trì, tỉnh Phú Thọ</p>
                  </div>
                </div>

                <div className={styles.group_info}>
                  <div className={styles.comp_title}>
                    <div className={styles.comp_img}><img src="/icons/address.svg" alt="Chi nhánh" /></div>
                    <h4>Chi nhánh Hàn Quốc:</h4>
                  </div>
                  <div className={styles.comp_detail}>
                    <p>Tầng 4, số 32 Bangulaen-ro, Mapo-gu, Seoul, Hàn Quốc</p>
                  </div>
                </div>

                <div className={styles.group_info}>
                  <div className={styles.comp_title}>
                    <div className={styles.comp_img}><img src="/icons/address.svg" alt="Chi nhánh" /></div>
                    <h4>Chi nhánh Thái Bình:</h4>
                  </div>
                  <div className={styles.comp_detail}>
                    <p>Quang Trung, Hưng Hà, Thái Bình</p>
                  </div>
                </div>

                <div className={styles.group_info}>
                  <div className={styles.comp_title}>
                    <div className={styles.comp_img}><img src="/icons/address.svg" alt="Chi nhánh" /></div>
                    <h4>Chi nhánh Vĩnh Phúc:</h4>
                  </div>
                  <div className={styles.comp_detail}>
                    <p>Đê Hến, Bá Hiến, Bình Xuyên, Vĩnh Phúc</p>
                  </div>
                </div>
              </div>

              <div className={styles.comp_info}>
                <div className={styles.group_info}>
                  <div className={styles.comp_title}>
                    <div className={styles.comp_img}><img src="/icons/director.svg" alt="Tổng giám đốc" /></div>
                    <h4>Tổng giám đốc:</h4>
                  </div>
                  <div className={styles.comp_detail}>
                    <p>Phùng Thị Thu Hồng</p>
                  </div>
                </div>

                <div className={styles.group_info}>
                  <div className={styles.comp_title}>
                    <div className={styles.comp_img}><img src="/icons/email.svg" alt="Email" /></div>
                    <h4>Email:</h4>
                  </div>
                  <div className={styles.comp_detail}>
                    <p>newlifecompany.pt@gmail.com</p>
                  </div>
                </div>

                <div className={styles.group_info}>
                  <div className={styles.comp_title}>
                    <div className={styles.comp_img}><img src="/icons/website.svg" alt="Website" /></div>
                    <h4>Website:</h4>
                  </div>
                  <div className={styles.comp_detail}>
                    <p>duhochanquocnewlife.com</p>
                  </div>
                </div>

                <div className={styles.group_info}>
                  <div className={styles.comp_title}>
                    <div className={styles.comp_img}><img src="/icons/hotline.svg" alt="Số điện thoại" /></div>
                    <h4>Số điện thoại:</h4>
                  </div>
                  <div className={styles.comp_detail}>
                    <p>0984.498.256 - 02103.993.995</p>
                  </div>
                </div>
              </div>

              <div className={styles.comp_info}>
                <div className={styles.group_info}>
                  <div className={styles.comp_title}>
                    <div className={styles.comp_img}><img src="/icons/director.svg" alt="Người đại diện" /></div>
                    <h4>Người đại diện HQ:</h4>
                  </div>
                  <div className={styles.comp_detail}>
                    <p>Kwon Jeong Man</p>
                  </div>
                </div>

                <div className={styles.group_info}>
                  <div className={styles.comp_title}>
                    <div className={styles.comp_img}><img src="/icons/hotline.svg" alt="Số điện thoại" /></div>
                    <h4>Số điện thoại:</h4>
                  </div>
                  <div className={styles.comp_detail}>
                    <p>010-9190-8868</p>
                  </div>
                </div>

                <div className={styles.group_info}>
                  <div className={styles.comp_title}>
                    <div className={styles.comp_img}><img src="/icons/money.svg" alt="Vốn điều lệ" /></div>
                    <h4>Vốn điều lệ:</h4>
                  </div>
                  <div className={styles.comp_detail}>
                    <p>900.000.000 (Bằng chữ: Chín trăm triệu đồng)</p>
                  </div>
                </div>
              </div>

            </div>

            {/* 3. Ban lãnh đạo */}
            <div id="management" className={styles.content_detail}>
              <h3 className={styles.content_title}>3. Ban lãnh đạo công ty</h3>
              <div className={styles.comp_manager}>
                <div className={styles.manager_detail}>
                  <img src="/images/director.png" alt="Tổng giám đốc" />
                  <strong>Tổng giám đốc: </strong>
                  <p>Phùng Thị Thu Hồng</p>
                </div>
                <div className={styles.manager_detail}>
                  <img src="/images/deputy.png" alt="Phó tổng giám đốc" />
                  <strong>Phó Tổng Giám Đốc: </strong>
                  <p>Nguyễn Văn Thể</p>
                </div>
                <div className={styles.manager_detail}>
                  <img src="/images/manager.png" alt="Giám đốc phát triển thị trường" />
                  <strong>GĐ phát triển thị trường: </strong>
                  <p>Nguyễn Hồng Hạnh</p>
                </div>
                <div className={styles.manager_detail}>
                  <img src="/images/teacher.png" alt="Giáo viên" />
                  <strong>Giáo viên: </strong>
                  <p>Đoàn Thị Thu Hương</p>
                </div>
              </div>
            </div>

            {/* 4. Lịch sử hình thành */}
            <div id="history" className={styles.content_detail}>
              <h3 className={styles.content_title}>4. Lịch sử hình thành</h3>
              <div className={styles.timeline}>
                {timelineData.map((item, index) => (
                  <div
                    key={index}
                    className={`${styles.timeline_item} ${item.color === "blue" ? styles.blue : styles.orange
                      }`}
                  >
                    {item.position === "top" ? (
                      <div className={styles.text_top}>
                        {item.text}
                      </div>
                    ) : (
                      <div className={styles.img_top}>
                        <img src="/icons/timeline_green.svg" alt="Timeline" />
                      </div>)
                    }
                    <div className={styles.year} style={{ backgroundColor: index % 2 === 0 ? "var(--primary-color)" : "orange" }}>
                      {item.year}
                    </div>
                    {item.position === "bottom" ? (
                      <div className={styles.text_bottom}>
                        {item.text}
                      </div>
                    ) : (
                      <div className={styles.img_bottom}>
                        <img src="/icons/timeline.svg" alt="Timeline" />
                      </div>)
                    }
                  </div>
                ))}
              </div>
            </div>

            {/* 5. Thông điệp công ty */}
            <div id="message" className={styles.content_detail}>
              <h3 className={styles.content_title}>5. Thông điệp công ty</h3>

              <div className={styles.group_mess}>
                <div className={styles.mess_title}>
                  <div className={styles.mess_img}><img src="/icons/rocket_green.svg" alt="Tầm nhìn" /></div>
                </div>
                <div className={styles.mess_detail}>
                  <h4>Tầm nhìn:</h4>
                  <p>Trở thành trung tâm du học Hàn Quốc uy tín, chất lượng thực chất và dịch vụ đồng hành hiệu quả.</p>
                </div>
              </div>

              <div className={styles.group_mess}>
                <div className={styles.mess_title}>
                  <div className={styles.mess_img}><img src="/icons/archery_target.svg" alt="Sứ mệnh" /></div>
                </div>
                <div className={styles.mess_detail}>
                  <h4>Sứ mệnh:</h4>
                  <p>Đào tạo chuyên sâu, định hướng phù hợp và đồng hành toàn diện trên hành trình du học Hàn Quốc</p>
                </div>
              </div>

              <div className={styles.group_mess}>
                <div className={styles.mess_title}>
                  <div className={styles.mess_img}><img src="/icons/diamond.svg" alt="Giá trị cốt lõi" /></div>
                </div>
                <div className={styles.mess_detail}>
                  <h4>Giá trị cốt lõi:</h4>
                  <p>Chúng tôi cam kết tận tâm đặt học sinh làm trung tâm. Với tinh thần trách nhiệm, chúng tôi theo sát học sinh xuyên suốt hành trình du học. Mọi dịch vụ đều hướng đến sự thực chất: Đào tạo thật, tư vấn đúng và hỗ trợ dài hạn</p>
                </div>
              </div>

            </div>

            {/* 6. Dịch vụ của NewLife */}
            <div id="service" className={styles.content_detail}>
              <h3 className={styles.content_title}>6. Dịch vụ của NewLife</h3>
              <div className={styles.service_info}>
                <p className={styles.service_title}>A. Đào tạo tiếng Hàn</p>
                <div className={styles.service_detail}>
                  <p><img src="/icons/check.svg" alt="Check" />Lớp học quy mô nhỏ (1:8)</p>
                  <p><img src="/icons/check.svg" alt="Check" />Phân lớp theo độ tuổi và năng lực</p>
                  <p><img src="/icons/check.svg" alt="Check" />Chương trình chuẩn TOPIK từ sơ cấp - trung cấp - cao cấp</p>
                  <p><img src="/icons/check.svg" alt="Check" />Luyện giao tiếp, kỹ năng phỏng vấn Visa</p>
                </div>
              </div>
              <div className={styles.service_info}>
                <p className={styles.service_title}>B. Tư vấn & định hướng du học</p>
                <div className={styles.service_detail}>
                  <p><img src="/icons/check.svg" alt="Check" />Lựa chọn trường - ngành - thành phố phù hợp</p>
                  <p><img src="/icons/check.svg" alt="Check" />Đánh giá năng lực & lập kế hoạch học tập cho từng học sinh</p>
                  <p><img src="/icons/check.svg" alt="Check" />Giải đáp chi tiết về học phí, cơ hội việc ;làm và lộ trình học tại Hàn Quốc</p>
                </div>
              </div>
              <div className={styles.service_info}>
                <p className={styles.service_title}>C. Hỗ trợ hồ sơ - Visa</p>
                <div className={styles.service_detail}>
                  <p><img src="/icons/check.svg" alt="Check" />Chuẩn bị hồ sơ du học</p>
                  <p><img src="/icons/check.svg" alt="Check" />Hướng dẫn chứng minh tài chính</p>
                  <p><img src="/icons/check.svg" alt="Check" />Luyện phỏng vấn với giáo viên Hàn Quốc</p>
                  <p><img src="/icons/check.svg" alt="Check" />Đồng hành trong suốt quá trình xét Visa</p>
                </div>
              </div>
              <div className={styles.service_info}>
                <p className={styles.service_title}>D. Hỗ trợ trước và sau xuất cảnh</p>
                <div className={styles.service_detail}>
                  <p><img src="/icons/check.svg" alt="Check" />Sắp xếp ký túc xá</p>
                  <p><img src="/icons/check.svg" alt="Check" />Đón tại sân bay</p>
                  <p><img src="/icons/check.svg" alt="Check" />Hỗ trợ nhập học, mở tài khoản ngân hàng, đăng ký cư trú</p>
                  <p><img src="/icons/check.svg" alt="Check" />Theo dõi tình hình học tập hàng tháng</p>
                </div>
              </div>
            </div>

            {/* 7. Quy trình tuyển sinh và đào tạo */}
            <div id="admission" className={styles.content_detail}>
              <h3 className={styles.content_title}>7. Quy trình tuyển sinh và đào tạo</h3>
              <div className={styles.process_admission}>
                <div className={styles.admission_detail}>
                  <span>01</span>
                  <div className={styles.admission_img}><img src="/icons/operator.svg" alt="Tư vấn" /></div>
                  <p>Tư vấn - Định hướng</p>
                </div>
                <div className={styles.admission_detail}>
                  <span>02</span>
                  <div className={styles.admission_img}><img src="/icons/notebook.svg" alt="Đánh giá" /></div>
                  <p>Đánh giá năng lực - Kiểm tra tiếng Hàn</p>
                </div>
                <div className={styles.admission_detail}>
                  <span>03</span>
                  <div className={styles.admission_img}><img src="/icons/teacher.svg" alt="Hợp đồng" /></div>
                  <p>Ký hợp đồng - Lập hồ sơ học tập</p>
                </div>
                <div className={styles.admission_detail}>
                  <span>04</span>
                  <div className={styles.admission_img}><img src="/icons/pencil.svg" alt="Đào tạo" /></div>
                  <p>Đào tạo tiếng Hàn - Luyện phỏng vấn Visa</p>
                </div>
                <div className={styles.admission_detail}>
                  <span>05</span>
                  <div className={styles.admission_img}><img src="/icons/passport.svg" alt="Hồ sơ" /></div>
                  <p>Nộp hồ sơ & chờ xét Visa</p>
                </div>
                <div className={styles.admission_detail}>
                  <span>06</span>
                  <div className={styles.admission_img}><img src="/icons/airplane.svg" alt="Nhập cảnh" /></div>
                  <p>Hướng dẫn xuất cảnh - Đón tiếp - Nhập học tại Hàn</p>
                </div>
                <div className={styles.admission_detail}>
                  <span>07</span>
                  <div className={styles.admission_img}><img src="/icons/group.svg" alt="Quản lý" /></div>
                  <p>Theo dõi - Quản lý - Đồng hành sau nhập học</p>
                </div>
              </div>
            </div>

            {/* 8. Điểm khác biệt của NewLife */}
            <div id="difference" className={styles.content_detail}>
              <h3 className={styles.content_title}>8. Điểm khác biệt của NewLife</h3>
              <div className={styles.difference_list}>
                <div className={styles.difference_item}>
                  <p>Đại diện người Hàn Quốc hỗ trợ 24/7</p>
                </div>
                <div className={styles.difference_item}>
                  <p>Thăm trường hàng tháng, trao đổi trực tiếp với nhà trường</p>
                </div>
                <div className={styles.difference_item}>
                  <p>Quản lý học sinh xuyên suốt - giảm thiểu tối đa rủi ro</p>
                </div>
                <div className={styles.difference_item}>
                  <p>Cam kết minh bạch chi phí - không phát sinh ngoài hợp đồng</p>
                </div>
                <div className={styles.difference_item}>
                  <p>Hệ thống lớp học nhỏ, đảm bảo chất lượng đào tạo</p>
                </div>
                <div className={styles.difference_item}>
                  <p>Tư vấn ngành học theo thị trường lao động Hàn Quốc</p>
                </div>
              </div>
            </div>

            {/* 9. Hệ thống trường đối tác */}
            <div id="university" className={styles.content_detail}>
              <h3 className={styles.content_title}>9. Hệ thống trường đối tác</h3>
              <div className={styles.university_list}>
                {listUni.map((item, i) => (
                  <div key={item.custom_id} className={styles.university_item}>
                    <img src={`/logos/${toString(item.name_en)}_logo.jpg`} alt='Trường Đại học Daegu' />
                    <h2 className={styles.kr_name}>{item.name_kr}</h2>
                    <h3 className={styles.vn_name}>{item.name_en} - {item.name_vn}</h3>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div >

      <Footer />
    </>
  );
}

export default IntroductionPage;